<div class="container-fluid main-container">
    <div class="row">
        <div class="col-md-6 image-container">
            <img class="image-background" src="../../assets/images/landing-museum-image.png">
        </div>
        <div class="col-md-6 content-container">
            <div class="title-container">
                <h1>{{'museum-slogan' | translate }}</h1>
                <div class="ruler"></div>
            </div>
            <div class="authenticator-container">
                <div class="not-connected" *ngIf="!authenticator.user">
                    <p class="contact">{{ 'auth.museumConnectMessage' | translate}}</p>
                    <amplify-authenticator [formFields]="formFields">
                        <ng-template amplifySlot="authenticated" let-user="user" let-signOut="signOut">
                            <h2>Welcome, {{ user.username }}!</h2>
                            <button (click)="signOut()">Sign Out</button>
                        </ng-template>
                    </amplify-authenticator>
                </div>
                <app-museum-auth-pseudo [templateID]="chosenTemplateID"></app-museum-auth-pseudo>
                <app-museum-auth-waiting *ngIf="showAuthWaiting"(onChooseMission)="setTemplateID($event)"></app-museum-auth-waiting>
                <div *ngIf="loading">
                    <div role="status" class="loading-div">
                        <museum-loader [whitify]="true"></museum-loader>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <img class="help-logo" data-testid="new-support-btn" (click)="openSupportForm()" [title]="'Help' | translate" src="../../assets/icons/help.svg">
    <img class="by-smarterplan-logo" src="../../assets/images/logos/logo-museum-bySmarterplan.png">

</div>